import { GzDashboardSmartViewsListWebComponent } from './gzDashboardSmartViewsList';

export { GzDashboardSmartViewsListWebComponent };
